import script from "./Homes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Homes.vue?vue&type=script&setup=true&lang=ts"

export default script